import { gql } from 'src/__generated__'

export default gql(`
  mutation createCanteen($data: CreateCanteenInput!) {
    createCanteen(data: $data) {
      id
    }
  }
`)
